import './../styles/Footer.css';

const ROW_1 = [
  { label: 'About', href: 'https://www.zilliqa.com/about/' },
  { label: 'Roadmap', href: 'https://www.zilliqa.com/roadmap/' },
  { label: 'Ecosystem', href: 'https://www.zilliqa.com/ecosystem/' },
  { label: 'Tools', href: 'https://www.zilliqa.com/tools/' },
  { label: 'FAQ', href: 'https://www.zilliqa.com/faq/' },
  { label: 'Incidents', href: 'https://www.zilliqa.com/incidents/' },
];

const ROW_2 = [
  { label: 'Blog', href: 'https://blog.zilliqa.com/' },
  { label: 'Developer Docs', href: 'https://dev.zilliqa.com/' },
  { label: 'Partners', href: 'https://www.zilliqa.com/partners/' },
];

const SOCIALS = [
  { name: 'X', href: 'https://x.com/zilliqa' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/checkpoint/challengesV2' },
  { name: 'Instagram', href: 'https://www.instagram.com/zilliqa_official/' },
  { name: 'Discord', href: 'https://discord.com/invite/zilliqa' },
  { name: 'Telegram', href: 'https://t.me/zilliqachat' },
];

function XIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#2fe1c9">
      <path d="M18.9 2H22l-7.6 8.7L23 22h-6.9l-5.4-6.9L4.4 22H1.3l8.1-9.3L1 2h7l4.9 6.3L18.9 2Zm-1.2 18h1.9L7.3 4H5.3l12.4 16Z" />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#2fe1c9">
      <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.7h.1c.5-1 1.9-2 3.8-2 4.1 0 4.9 2.7 4.9 6.2V21h-4v-5.7c0-1.4 0-3.2-2-3.2s-2.3 1.5-2.3 3.1V21h-4V9Z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="#2fe1c9" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4" stroke="#2fe1c9" strokeWidth="1.8" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="#2fe1c9" />
    </svg>
  );
}

function DiscordIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M8.5 9.5c1.5-.7 3-.7 4.5 0M6 16c3.5 1.2 8.5 1.2 12 0M8 17.5c-3-1-5-2.7-5-5.5 0-3.2 1.7-6.3 4.3-7.5.6.7 1 1.4 1.3 2.1M16 17.5c3-1 5-2.7 5-5.5 0-3.2-1.7-6.3-4.3-7.5-.6.7-1 1.4-1.3 2.1"
        stroke="#2fe1c9"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="9" cy="12.5" r="1.1" fill="#2fe1c9" />
      <circle cx="15" cy="12.5" r="1.1" fill="#2fe1c9" />
    </svg>
  );
}

function TelegramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 4 2.5 11.4c-1 .4-1 1.7.1 2l4.4 1.4 1.7 5.3c.3.9 1.4 1.1 2.1.4l2.4-2.3 4.5 3.3c.8.6 2 .2 2.2-.8L22.7 5.2c.2-1-.7-1.7-1.7-1.2Z"
        stroke="#2fe1c9"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M8.9 14.8 18 7.2" stroke="#2fe1c9" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

const ICON_MAP = {
  X: XIcon,
  LinkedIn: LinkedInIcon,
  Instagram: InstagramIcon,
  Discord: DiscordIcon,
  Telegram: TelegramIcon,
};

export default function Footer() {
  return (
    <footer className="footer">
      <nav className="footer__row">
        {ROW_1.map((link) => (
          <a key={link.label} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>
      <nav className="footer__row">
        {ROW_2.map((link) => (
          <a key={link.label} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>

      <div className="footer__socials">
        {SOCIALS.map((social) => {
          const Icon = ICON_MAP[social.name];
          return (
            <a
              key={social.name}
              href={social.href}
              aria-label={social.name}
              className="footer__social-link"
            >
              <Icon />
            </a>
          );
        })}
      </div>

      <div className="footer__divider" />

      <p className="footer__copyright">
        © Powered by Zilliqa, 2026,{' '}
        <a href="https://www.zilliqa.com/privacy-policy/">Privacy Policy</a>
      </p>
    </footer>
  );
}